export default __webpack_public_path__ + "static/media/completed.6deb2ed3.svg";